import React from "react";
import { Construction } from "lucide-react";
import { Badge } from "./badge";
import { PageHeader } from "./page-header";

// TO-DO: Remove this component once every section is fully implemented.
export function TodoPlaceholder({ title, description }: { title: React.ReactNode; description?: string }) {
  return (
    <div>
      <PageHeader
        title={title}
        actions={
          // TO-DO badge — visible in UI to signal pending implementation
          <Badge variant="warning" className="mt-1">TO-DO</Badge>
        }
      />

      {/* TO-DO: Replace placeholder body with real data and UI */}
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-warning/40 bg-warning/5 py-20 text-center">
        <Construction className="mb-3 h-10 w-10 text-warning/50" />
        <p className="text-sm font-semibold text-warning-foreground">TO-DO: Not yet implemented</p>
        <p className="mt-1 max-w-sm text-xs text-muted-foreground">
          {description ?? "This section is pending backend functionality, data fetching, and full UI implementation."}
        </p>
      </div>
    </div>
  );
}
